import { render, staticRenderFns } from "./RoadmapDefault.vue?vue&type=template&id=04d28242&scoped=true"
import script from "./RoadmapDefault.vue?vue&type=script&lang=ts"
export * from "./RoadmapDefault.vue?vue&type=script&lang=ts"
import style0 from "./RoadmapDefault.vue?vue&type=style&index=0&id=04d28242&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d28242",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04d28242')) {
      api.createRecord('04d28242', component.options)
    } else {
      api.reload('04d28242', component.options)
    }
    module.hot.accept("./RoadmapDefault.vue?vue&type=template&id=04d28242&scoped=true", function () {
      api.rerender('04d28242', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/support/RoadmapDefault.vue"
export default component.exports